import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    payCreditTotalCost: {
        marginTop: '70px',
    },
}));